const devAppidMap = {
  /** 增项小程序 */
  EM_ADDITION: 'wx2c33e1f84e64fd7a',
  /** 车间小程序 */
  WORKSHOP: 'wx294bc350ae76356b'
}

const prodAppidMap: typeof devAppidMap = {
  EM_ADDITION: 'wx07392b0bb2bef33b',
  WORKSHOP: 'wx8240a3e0fa505fb9'
}

/** 小程序appid */
export const mpAppidMap = process.env.RUN_ENV === 'production' ? prodAppidMap : devAppidMap
